//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable import/no-cycle */
/* eslint-disable no-lonely-if */
/* eslint-disable no-param-reassign */
import {
  ref, computed, onMounted, getCurrentInstance,
} from '@vue/composition-api'
import {
  mdiClose, mdiBookmarkOutline, mdiExportVariant, mdiCheckBold, mdiTrashCanOutline, mdiPlay, mdiStop,
} from '@mdi/js'
import { useUtils } from '@core/libs/i18n'
import {
  formatCurrency,
  isAndroid,
  isIOS,
  useRouter,
  defaultDownloadAppByOS,
} from '@core/utils'
import themeConfig from '@themeConfig'
import Axios from 'axios'
import { required, emailValidator, minLengthValidator } from '@core/utils/validation'
import RepeatRequest from '@core/utils/repeatRequest.services'
import moment from 'moment'
import { success } from '@core/utils/toasted'
import { getI18nLanguage } from '@/plugins/i18n'

export default {
  components: {

  },
  setup() {
    const vm = getCurrentInstance().proxy
    const BASE_URL = `${process.env.VUE_APP_API_URL_BACKEND}v1/`

    const repeat = new RepeatRequest()
    const repeatForPercent = new RepeatRequest()
    const { route } = useRouter()
    const { params, query } = route.value

    const { t } = useUtils()
    const startCreateHighlight = ref(false)
    const showInputName = ref(false)
    const highlightName = ref('')
    const nameInput = ref(null)
    const currentTimeVideo = ref(1)
    const camSelected = ref(1)
    const highlightSelected = ref(0)
    const actionBtnsDom = ref(null)
    const camsContainerDom = ref(null)
    const newHighlight = ref({
      user_id: '',
      name: '',
      creation_date: moment().format('YYYY-MM-DD'),
      highlight_type: 'H',
      start_time: 0,
      end_time: 0,
      video_id: 0,
      recording_id: 0,
    })
    const newHighlightMV = ref({
      name: '',
      thumbnail: '',
      highlight_id: null,
    })
    const manualViewer = ref(false)
    const videoRNData = ref({
      highlights: [],
      detail_str: '',
      status: 'A',
      status_str: '',
      highlights_times: [],
      sprite_url: null,
    })
    const listFolder = ref([])
    const errorMessages = ref([])
    const showCustomControls = ref(true)
    const myPlaylist = ref([])
    const inFullscreen = ref(false)
    const showModeBtn = ref(false)
    const videoLoaded = ref(false)
    const playerDuration = ref(1)
    const touchDuration = ref(0)
    const isLightMode = ref(false)
    const showGuide = ref(false)
    const loading = ref(true)
    const showDeleteHighlightDialog = ref(false)
    const showUnSaveHighlightDialog = ref(false)
    const showHighlightCreated = ref(false)
    const endGuide = ref(false)
    const highlightPendingList = ref([])
    const cameraPositions = ref([])
    const processingPercent = ref(0)
    const isAndroidComputed = computed(() => isAndroid())
    const isIOSComputed = computed(() => isIOS())
    let player = null
    let timeoutHighlight = null
    let intervalHighlight = null
    let modeBtnTime = null
    let touchInterval = null
    let touchTimeout = null
    let intervalT = null
    const getVrInstance = (elPlayer = player) => {
      if (!elPlayer || typeof elPlayer.vr !== 'function') return null
      try {
        const plugin = elPlayer.vr()
        if (!plugin || typeof plugin !== 'object') return null

        return plugin
      } catch (error) {
        return null
      }
    }
    const getVrCamera = (elPlayer = player) => getVrInstance(elPlayer)?.camera || null
    const getVrControls = (elPlayer = player) => getVrInstance(elPlayer)?.controls3d || null
    const highlightNameRules = {
      required: value => !!value || 'Field is required',
    }
    function arrayIsNotEmpty(arr) {
      if (!arr) return false
      if (arr.length > 0) return true

      return false
    }
    const initTouchEvents = elPlayer => {
      elPlayer.on('touchstart', e => {
        console.log('touchstart', e)
        clearInterval(intervalT)
        touchDuration.value = 0
        clearInterval(touchInterval)
        if (String(e.target.id).includes('player_html5_api')) {
          clearTimeout(modeBtnTime)
          clearTimeout(touchTimeout)
          showModeBtn.value = !showModeBtn.value
          modeBtnTime = setTimeout(() => {
            showModeBtn.value = false
          }, 3000)
        }
        touchInterval = setInterval(() => {
          touchDuration.value += 1
        }, 10)
      })

      elPlayer.on('touchend', touchendEvent => {
        if (manualViewer.value) {
          // setPassGuide()
          // eslint-disable-next-line no-unused-expressions
          typeof DeviceMotionEvent !== 'undefined'
            && typeof DeviceMotionEvent.requestPermission === 'function'
            && DeviceMotionEvent.requestPermission()
              .then(ev => {
                // eslint-disable-next-line no-unused-expressions
                ev === 'granted' && window.addEventListener('devicemotion', e => { console.log(e) })
              })
              .catch(console.error)

          touchDuration.value = 0
        }
        clearTimeout(touchTimeout)

        if (document.querySelectorAll('.vjs-touch-nav').length && touchDuration.value < 50) {
          if (document.querySelectorAll('.vjs-touch-nav')[0].classList.contains('touch-show')) {
            if (!touchendEvent.target.className.includes('control')) {
              document.querySelectorAll('.vjs-touch-nav')[0].classList.remove('touch-show')
              elPlayer.controlBar.hide()
            }
          } else {
            document.querySelectorAll('.vjs-touch-nav')[0].classList.add('touch-show')
            elPlayer.controlBar.show()
            touchTimeout = setTimeout(() => {
              showModeBtn.value = false
              document.querySelectorAll('.vjs-touch-nav')[0].classList.remove('touch-show')
              if (elPlayer.controlBar) elPlayer.controlBar.hide()
            }, 3000)
          }
        }
      })
    }

    function restartPlayer() {
      loading.value = true
      player.dispose()
      const elplayer = document.createElement('video')
      elplayer.setAttribute('id', 'player')
      elplayer.setAttribute('controls', 'player')
      elplayer.setAttribute('crossorigin', 'anonymous')
      elplayer.setAttribute('preload', 'metadata')
      elplayer.setAttribute('muted', 'muted')
      elplayer.setAttribute('autoplay', 'true')
      elplayer.setAttribute('playsinline', 'playsinline')
      elplayer.classList.add('video-js')
      elplayer.classList.add('player')
      elplayer.classList.add('vjs-fluid')

      // if (isLightMode.value) {
      //   elplayer.classList.add('bg-light')
      // } else {
      //   elplayer.classList.remove('bg-light')
      // }

      const wrapper = document.getElementById('player-wrapper')
      wrapper.appendChild(elplayer)
      const srcUrl = videoRNData.value.left_video_url || videoRNData.value.video_url || videoRNData.value.stitched_video_url || ''
      const hasEndTag = String(srcUrl).includes('endtag=true')
      player = window.videojs('player', {
        disablePictureInPicture: true,
        aspectRatio: '16:9',
        liveui: !hasEndTag,
        controlBar: {
          fullscreenToggle: false,
        },
        userActions: {
          doubleClick: false,
        },
      })

      window.removeEventListener('deviceorientation', e => console.log(e))
    }

    async function sendUserActivities(videoId = null, highlightId = null, errorCode = null) {
      const metadata = {
        errorCode,
        osName: query?.osName,
        osVersion: query?.osVersion,
        modelId: query?.modelId,
        modelName: query?.modelName,
      }

      const axions = new Axios.Axios({})
      try {
        await axions.post(
          `${BASE_URL}user/activity/`,
          JSON.stringify(
            {
              user_id: query?.userId,
              video_id: videoId,
              highlight_id: highlightId,
              action: 'Video Player Error',
              meta_data: metadata,
            },
          ),
          {
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              'Accept-Language': getI18nLanguage(),
              'el-token': `Bearer ${params.hash}`,
            },
          },
        )
      } catch (error) {
        console.log(error)
      }
    }

    async function sendUserActivityInManualViewer(videoId = null, highlightId = null) {
      const axions = new Axios.Axios({})
      try {
        await axions.post(
          `${BASE_URL}user/activity/`,
          JSON.stringify(
            {
              user_id: query?.userId,
              video_id: videoId,
              highlight_id: highlightId,
              action: 'View Video App 180',
            },
          ),
          {
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              'Accept-Language': getI18nLanguage(),
              'el-token': `Bearer ${params.hash}`,
            },
          },
        )
      } catch (error) {
        console.log(error)
      }
    }

    function setCameraConfig(instancePlayer, defaultZoom = 1, defaultFov = 50) {
      const elPlayer = instancePlayer
      const vrInstance = getVrInstance(elPlayer)
      const controls3d = vrInstance?.controls3d
      const orbitControls = controls3d?.orbit
      const camera = vrInstance?.camera
      if (!orbitControls || !camera) return

      let zoom = defaultZoom
      let fov = defaultFov
      let aspectRatio = 2.2
      const marginFix = 0.08
      if (elPlayer && elPlayer.videoWidth && elPlayer.videoHeight) {
        const width = elPlayer.videoWidth()
        const height = elPlayer.videoHeight()
        aspectRatio = width / height
        console.log('Video width:', width, 'height:', height, 'aspect ratio:', aspectRatio)
      }
      const cameraVerticalRangeMax = videoRNData.value.camera_vertical_range_max
      const cameraVerticalMin = videoRNData.value.camera_vertical_range_min

      let maxPolarAngle = cameraVerticalRangeMax * (Math.PI / 166)
      let minPolarAngle = cameraVerticalMin * (Math.PI / 166)
      console.log(minPolarAngle)
      touchDuration.value = 0
      if (aspectRatio < 2.2) {
        maxPolarAngle = cameraVerticalRangeMax * (Math.PI / 180)
        minPolarAngle = cameraVerticalMin * (Math.PI / 180)
        orbitControls.maxAzimuthAngle = Math.PI / 2.6
        orbitControls.minAzimuthAngle = -Math.PI / 2.6
        zoom = 1
        fov = 50
        camera.zoom = zoom
        camera.fov = fov
        camera.updateProjectionMatrix()
      } else {
        orbitControls.maxAzimuthAngle = -Math.PI + aspectRatio + marginFix
        orbitControls.minAzimuthAngle = -Math.PI / (Math.PI / aspectRatio) - marginFix
        camera.zoom = zoom
        camera.fov = fov
        camera.updateProjectionMatrix()
      }

      orbitControls.maxPolarAngle = maxPolarAngle
      orbitControls.minPolarAngle = minPolarAngle
      controls3d.update?.()
    }

    function setManualViewerVideo(currentTime, enableMotion = true, onFiinish = null) {
      try {
        newHighlightMV.value = {
          name: '',
          thumbnail: '',
          highlight_id: 0,
        }
        const highlightTime = videoRNData.value.highlights_times.map((timeh, ih) => ({
          time: timeh, text: String(timeh), overlayText: String(ih),
        }))
        player.src({ type: 'video/mp4', src: videoRNData.value.stitched_video_url })
        // eslint-disable-next-line no-use-before-define
        if (videoRNData.value.stitched_video_url) {
          // eslint-disable-next-line no-use-before-define
          generateBarManualViewerBtn(player, 'vjs-icon-cam')
        }
        player.nuevo({
          shareMenu: false,
          zoomMenu: false,
          contextMenu: false,
          relatedMenu: false,
          rateMenu: false,
          settingsButton: false,
        })

        if (!player.mediainfo) {
          player.mediainfo = {}
        }

        if (!player.mediainfo.projection) {
          player.mediainfo.projection = '360'
        }

        player.vr({ projection: '360', motionControls: true })

        player.load()
        player.ready(() => {
          player.currentTime(currentTime)

          setTimeout(() => {
            loading.value = false
            // eslint-disable-next-line no-use-before-define
            setPassGuide()
            if (onFiinish) {
              onFiinish()
            }
          }, 6000)
        })
        window.addEventListener('deviceorientation', event => {
          // Rotación alrededor del eje Z (0 a 360 grados)
          const { beta } = event // Inclinación frontal/trasera del dispositivo (-180 a 180 grados)
          if (beta > 80) {
            const vrInstance = getVrInstance(player)
            const camera = vrInstance?.camera
            if (camera?.position?.set) {
              camera.position.set(camera.position.x, 0, camera.position.z)
              vrInstance?.controls3d?.update?.()
            }
          }
        })
        player.on('loadedmetadata', () => {
          const srcUrl = videoRNData.value.stitched_video_url || ''
          if (srcUrl.includes('endtag=true')) {
            player.removeClass('vjs-live')
            player.removeClass('vjs-liveui')
            if (player.liveTracker && typeof player.liveTracker.stopTracking === 'function') {
              player.liveTracker.stopTracking()
            }
          }
          if (videoRNData.value.stitched_video_url && (videoRNData.value.left_video_url || videoRNData.value.video_url)) {
            // eslint-disable-next-line no-use-before-define
            generateBarManualViewerBtn(player, 'vjs-icon-cam')
            // eslint-disable-next-line no-use-before-define
            generateFullScreenBtn(player, inFullscreen.value ? 'vjs-icon-fsExit' : 'vjs-icon-fs', 12)
          } else {
            // eslint-disable-next-line no-use-before-define
            generateFullScreenBtn(player, inFullscreen.value ? 'vjs-icon-fsExit' : 'vjs-icon-fs', 11)
          }
          // eslint-disable-next-line no-use-before-define
          addBtnActionsInsidePlayer(actionBtnsDom.value, camsContainerDom.value)
          // eslint-disable-next-line no-use-before-define
          generateRateBtn(player)
          // eslint-disable-next-line no-use-before-define
          setHighlightMarks(player, highlightTime)
          document.getElementById('player-wrapper').click()
          sendUserActivityInManualViewer(params.user)

          // const timer = setInterval(() => {
          //   if (player.vr().camera) {
          //     clearInterval(timer)
          setTimeout(() => {
            const vrInstance = getVrInstance(player)
            const camera = vrInstance?.camera
            if (camera?.position?.set) {
              camera.position.set(-(Math.PI * 3), 0, 0)
            }
            setCameraConfig(player)
          }, 1000)

          if (!enableMotion) {
            const vrInstance = getVrInstance(player)
            const orientationControls = vrInstance?.controls3d?.orientation
            if (orientationControls?.disableDevice) {
              console.log('entra', enableMotion)
              setTimeout(() => {
                orientationControls.disableDevice()
              }, 1000)
            }
          }
          touchTimeout = setTimeout(() => {
            showModeBtn.value = false
            document.querySelectorAll('.vjs-touch-nav')[0].classList.remove('touch-show')
            player.controlBar.hide()
          }, 4000)
        })

        player.on('touchstart', e => {
          console.log('touchstart', e)
          setCameraConfig(player)
          clearInterval(touchInterval)
          clearTimeout(touchTimeout)
          touchInterval = setInterval(() => {
            touchDuration.value += 1
          }, 10)
        })

        player.on('touchend', touchendEvent => {
          clearInterval(touchInterval)
          if (touchDuration.value < 50) {
            if (document.querySelectorAll('.vjs-touch-nav')[0].classList.contains('touch-show')) {
              if (!touchendEvent.target.className.includes('control') && !touchendEvent.target.className.includes('actionBtn-title')) {
                document.querySelectorAll('.vjs-touch-nav')[0].classList.remove('touch-show')
                player.controlBar.hide()
                showModeBtn.value = false
              }
            } else {
              console.log(touchendEvent.target.className)
              document.querySelectorAll('.vjs-touch-nav')[0].classList.add('touch-show')
              player.controlBar.show()
              if (!touchendEvent.target.className.includes('actionBtn-title')) {
                showModeBtn.value = true
              }
              touchTimeout = setTimeout(() => {
                showModeBtn.value = false
                document.querySelectorAll('.vjs-touch-nav')[0].classList.remove('touch-show')
                player.controlBar.hide()
              }, 4000)
            }
          }
        })

        player.on('error', () => {
          console.log('error', player.error())
          sendUserActivities(params.user, null, player.error())
        })
        window.addEventListener('resize', () => {
          if (manualViewer.value) {
            const vrInstance = getVrInstance(player)
            const camera = vrInstance?.camera
            if (camera) {
              camera.aspect = inFullscreen.value ? 2.1 : 1.77
              camera.updateProjectionMatrix?.()
            }
            vrInstance?.controls3d?.handleResize?.()
          }
        })

        // player.vr().controls3d.update()
      } catch (error) {
        console.log('🚀 ~ setManualViewerVideo ~ error:', error)
      }
      // eslint-disable-next-line no-use-before-define
      // eslint-disable-next-line no-unused-expressions
      typeof DeviceMotionEvent !== 'undefined'
        && typeof DeviceMotionEvent.requestPermission === 'function'
        && DeviceMotionEvent.requestPermission()
          .then(ev => {
            // eslint-disable-next-line no-unused-expressions
            ev === 'granted' && window.addEventListener('devicemotion', e => { console.log(e) })
          })
          .catch(console.error)
    }

    function setTrackedVideo(currentTime) {
      const highlightTime = videoRNData.value.highlights_times.map((timeh, ih) => ({
        time: timeh, text: String(timeh), overlayText: String(ih),
      }))
      player.nuevo({
        playlistUI: false,
        playlistShow: false,
        playlistAutoHide: false,
        playlistNavigation: false,
        playlistRepeat: false,
        shareMenu: false,
        settingsButton: false,
      })
      if (videoRNData.value.video_type === 'S') {
        player.thumbnails({ responsive: true })
        myPlaylist.value = [
          {
            sources: [{ src: videoRNData.value.left_video_url || videoRNData.value.video_url, type: 'video/mp4' }],
            thumb: '',
            slideImage: '',
            title: 'video',
            duration: '01:13',
          },
          {
            sources: [{ src: videoRNData.value.right_video_url, type: 'video/mp4' }],
            thumb: '',
            slideImage: '',
            title: 'video',
            duration: '01:13',
          },
        ]

        // player.playlist(myplaylist)
      }
      if (videoRNData.value.stitched_video_url) {
        // eslint-disable-next-line no-use-before-define
        generateBarManualViewerBtn(player, 'vjs-icon-vr')
      }
      player.src({ type: 'video/mp4', src: videoRNData.value.left_video_url || videoRNData.value.video_url })

      player.load()
      player.ready(() => {
        player.currentTime(currentTime)
        player.play()
      })
      player.on('loadedmetadata', () => {
        const srcUrl = videoRNData.value.left_video_url || videoRNData.value.video_url || ''
        if (srcUrl.includes('endtag=true')) {
          player.removeClass('vjs-live')
          player.removeClass('vjs-liveui')
          if (player.liveTracker && typeof player.liveTracker.stopTracking === 'function') {
            player.liveTracker.stopTracking()
          }
        }
        if (videoRNData.value.stitched_video_url && (videoRNData.value.left_video_url || videoRNData.value.video_url)) {
          // eslint-disable-next-line no-use-before-define
          generateBarManualViewerBtn(player)
          // eslint-disable-next-line no-use-before-define
          generateFullScreenBtn(player, inFullscreen.value ? 'vjs-icon-fsExit' : 'vjs-icon-fs', 12)
        } else {
          // eslint-disable-next-line no-use-before-define
          generateFullScreenBtn(player, inFullscreen.value ? 'vjs-icon-fsExit' : 'vjs-icon-fs', 11)
        }
        // eslint-disable-next-line no-use-before-define
        generateRateBtn(player)

        // eslint-disable-next-line no-use-before-define
        setHighlightMarks(player, highlightTime)
        setTimeout(() => {
          // eslint-disable-next-line no-use-before-define
          addBtnActionsInsidePlayer(actionBtnsDom.value, camsContainerDom.value)
        }, 1000)
        loading.value = false
        touchTimeout = setTimeout(() => {
          showModeBtn.value = false
          document.querySelectorAll('.vjs-touch-nav')[0].classList.remove('touch-show')
          player.controlBar.hide()
        }, 4000)
      })
      initTouchEvents(player)

      player.on('error', () => {
        console.log('error', player.error())
        sendUserActivities(params.user, null, player.error())
      })
    }

    function changeTo() {
      const currentTime = player.currentTime()
      restartPlayer()
      if (!manualViewer.value) {
        manualViewer.value = true
        setManualViewerVideo(currentTime)
      } else {
        manualViewer.value = false
        setTrackedVideo(currentTime, videoRNData)
      }
    }

    function generateBarManualViewerBtn(elplayer, className = 'vjs-icon-vr') {
      player.getChild('controlBar').removeChild('vrbtn', {}, 8)
      const btn = window.videojs.getComponent('Button')
      const vrBtn = window.videojs.extend(btn, {
        constructor() {
          // eslint-disable-next-line prefer-rest-params
          btn.apply(this, arguments)
          this.addClass(className)
        },
        handleClick() {
          changeTo()
        },
      })

      window.videojs.registerComponent('vrbtn', vrBtn)
      elplayer.getChild('controlBar').addChild('vrbtn', {}, 8)
    }

    function ingreseRate() {
      const currentRate = player.playbackRate()
      player.getChild('controlBar').removeChild('rateBtn', {}, 9)
      if (currentRate === 1) {
        player.playbackRate(2)
        // eslint-disable-next-line no-use-before-define
        generateRateBtn(player, 'vjs-icon-2x')
      } else {
        player.playbackRate(1)
        // eslint-disable-next-line no-use-before-define
        generateRateBtn(player, 'vjs-icon-1x')
      }
    }
    function requestMotionPermission() {
      // eslint-disable-next-line no-use-before-define
      // eslint-disable-next-line no-unused-expressions
      typeof DeviceMotionEvent !== 'undefined'
        && typeof DeviceMotionEvent.requestPermission === 'function'
        && DeviceMotionEvent.requestPermission()
          .then(ev => {
            // eslint-disable-next-line no-unused-expressions
            ev === 'granted' && window.addEventListener('devicemotion', e => { console.log(e) })
          })
          .catch(console.error)
    }

    function generateRateBtn(elplayer, className = 'vjs-icon-1x') {
      elplayer.getChild('controlBar').removeChild('rateBtn', {}, 9)
      const btn = window.videojs.getComponent('Button')
      const rateBtn = window.videojs.extend(btn, {
        constructor() {
          // eslint-disable-next-line prefer-rest-params
          btn.apply(this, arguments)
          this.addClass(className)
        },
        handleClick() {
          ingreseRate()
        },
      })

      window.videojs.registerComponent('rateBtn', rateBtn)
      elplayer.getChild('controlBar').addChild('rateBtn', {}, 9)
    }

    function setFullScreen(elPlayer, sendPostMessage = true) {
      try {
        showModeBtn.value = false
        elPlayer.controlBar.hide()
        inFullscreen.value = !inFullscreen.value
        if (document.querySelectorAll('.vjs-touch-nav')[0]) {
          document.querySelectorAll('.vjs-touch-nav')[0].classList.remove('touch-show')
        }
        console.log('infulll', inFullscreen.value)
        const vrInstance = getVrInstance(elPlayer)
        const camera = vrInstance?.camera
        const controls3d = vrInstance?.controls3d
        if (inFullscreen.value) {
          // eslint-disable-next-line no-use-before-define
          generateFullScreenBtn(elPlayer, 'vjs-icon-fsExit')
          if (camera) {
            camera.aspect = 2.1
            camera.updateProjectionMatrix?.()
            controls3d?.handleResize?.()
            controls3d?.update?.()
          }
        } else {
          // eslint-disable-next-line no-use-before-define
          generateFullScreenBtn(elPlayer)
          if (camera) {
            camera.aspect = 1.77
            camera.updateProjectionMatrix?.()
            controls3d?.handleResize?.()
            controls3d?.update?.()
          }
        }
        if (window.ReactNativeWebView && sendPostMessage) {
          window.ReactNativeWebView.postMessage('fullscreenchange')
        }
      } catch (error) {
        console.log('error setFullScreen', error)
      }
    }

    function generateFullScreenBtn(elplayer, className = 'vjs-icon-fs', position = 11) {
      try {
        elplayer.getChild('controlBar').removeChild('fsBtn', {}, position)
        const btn = window.videojs.getComponent('Button')
        const fsBtn = window.videojs.extend(btn, {
          constructor() {
            // eslint-disable-next-line prefer-rest-params
            btn.apply(this, arguments)
            this.addClass(className)
          },
          handleClick() {
            setFullScreen(elplayer)
          },
        })

        window.videojs.registerComponent('fsBtn', fsBtn)
        elplayer.getChild('controlBar').addChild('fsBtn', {}, position)
      } catch (error) {
        console.log(error)
      }
    }

    function arrayToObject(array) {
      const obj = {}
      array.forEach(item => {
        const key = Object.keys(item)[0]
        obj[key] = item[key]
      })

      return obj
    }

    function interpolateLinear(start, end, factor) {
      return start + factor * (end - start)
    }

    function playHighlightLoop(startTime, endTime, currentTime, elplayer, loop = false, objCameraPositions = {}) {
      const frameRate = 20
      if (currentTime >= endTime && loop) {
        clearInterval(intervalT)
        elplayer.currentTime(startTime)
        if (manualViewer.value) {
          intervalT = setInterval(() => {
            const currentFrame = Math.floor(elplayer.currentTime() * frameRate)
            const nextFrame = Math.floor((elplayer.currentTime() + 0.125) * frameRate)
            const interpolatedPosition = {
              x: interpolateLinear(objCameraPositions[`${currentFrame}`].x, objCameraPositions[`${nextFrame}`].x, 0.5),
              y: interpolateLinear(objCameraPositions[`${currentFrame}`].y, objCameraPositions[`${nextFrame}`].y, 0.5),
              z: interpolateLinear(objCameraPositions[`${currentFrame}`].z, objCameraPositions[`${nextFrame}`].z, 0.5),
            }
            if (objCameraPositions[`${currentFrame}`]) {
              const vrInstance = getVrInstance(elplayer)
              const camera = vrInstance?.camera
              if (camera?.position?.set) {
                camera.position.set(
                  objCameraPositions[`${currentFrame}`].x,
                  objCameraPositions[`${currentFrame}`].y,
                  objCameraPositions[`${currentFrame}`].z,
                )

                // eslint-disable-next-line no-plusplus
                for (let i = 0; i < interpolatedPosition.length; i++) {
                  camera.position.set(interpolatedPosition.x, interpolatedPosition.y, interpolatedPosition.z)
                }
              }
            }
          }, 60 / frameRate)
        }
      }
    }

    function onStopHighlight() {
      clearTimeout(timeoutHighlight)
      clearInterval(intervalHighlight)
      const objCameraPositions = arrayToObject(cameraPositions.value)
      showInputName.value = true
      newHighlight.value = {
        ...newHighlight.value,
        end_time: player.currentTime(),
        cam_coords: cameraPositions.value,
      }
      player.currentTime(newHighlight.value.start_time)
      const frameRate = 20
      if (manualViewer.value) {
        intervalT = setInterval(() => {
          const frameInterval = Math.floor(player.currentTime() * frameRate)

          if (objCameraPositions[`${frameInterval}`]) {
            const vrInstance = getVrInstance(player)
            const camera = vrInstance?.camera
            if (camera?.position?.set) {
              camera.position.set(
                objCameraPositions[`${frameInterval}`].x,
                objCameraPositions[`${frameInterval}`].y,
                objCameraPositions[`${frameInterval}`].z,
              )
            }
          }
        }, 125 / frameRate)
      }
      player.on('timeupdate', () => {
        const current = player.currentTime()
        if (current < newHighlight.value.start_time || current > newHighlight.value.end_time) {
          clearInterval(intervalT)
        }
        playHighlightLoop(newHighlight.value.start_time, newHighlight.value.end_time, current, player, true, objCameraPositions)
      })
    }

    function onStartHighlight() {
      const frameRate = 20
      const elCameraPositions = []
      let frameInterval = null
      const p = document.getElementsByClassName('vjs-touch-nav')
      if (p.length) {
        p[0].style = 'display: none'
      }

      player.play()
      startCreateHighlight.value = true
      newHighlight.value = {
        name: '',
        start_time: player.currentTime(),
      }
      player.controls(false)
      timeoutHighlight = setInterval(() => {
        onStopHighlight()
      }, 30000)
      let elcurrentTime = 1
      intervalHighlight = setInterval(() => {
        elcurrentTime += 1
        if (manualViewer.value) {
          const vrInstance = getVrInstance(player)
          const camera = vrInstance?.camera
          if (camera?.position) {
            clearInterval(frameInterval)
            frameInterval = setInterval(() => {
              const currentFrame = Math.floor(player.currentTime() * frameRate)
              const currentCamera = getVrInstance(player)?.camera
              if (currentCamera?.position) {
                elCameraPositions.push({
                  [currentFrame]: {
                    x: currentCamera.position.x,
                    y: currentCamera.position.y,
                    z: currentCamera.position.z,
                  },
                })
              }
            }, 60 / frameRate)
          }
        }
        cameraPositions.value = elCameraPositions
        currentTimeVideo.value = Math.floor(elcurrentTime)
      }, 1000)
    }

    function onSelectHighlight(item) {
      highlightSelected.value = item.id
      clearInterval(intervalT)
      if (item?.side === 'L') {
        if (camSelected.value === 1) {
          player.currentTime(item.start_second)
        } else {
          // eslint-disable-next-line no-use-before-define
          onSelectCam('left', item.start_second)
        }
      } else if (item?.side === 'R') {
        if (camSelected.value === 2) {
          player.currentTime(item.start_second)
        } else {
          // eslint-disable-next-line no-use-before-define
          onSelectCam('right', item.start_second)
        }
      } else {
        if (arrayIsNotEmpty(item.cam_coords) && !manualViewer.value) {
          const coordinates = item.cam_coords
          const objCameraPositions = arrayToObject(coordinates)
          const yValues = coordinates.map(el => Object.values(el)[0].y)
          const avgY = yValues.reduce((sum, val) => sum + val, 0) / (yValues.length || 1)
          restartPlayer()
          setManualViewerVideo(item.start_second, false, () => {
            manualViewer.value = true
            player.currentTime(item.start_second)
            const orientationControls = getVrControls(player)?.orientation
            orientationControls?.disableDevice?.()
            document.getElementById('player').style.pointerEvents = 'none'
            const frameRate = 20
            player.off('timeupdate')
            player.currentTime(item.start_second)
            player.on('timeupdate', () => {
              const current = player.currentTime()
              if (current < item.start_second || current > item.end_second) {
                clearInterval(intervalT)
                const orientation = getVrControls(player)?.orientation
                orientation?.enableDevice?.()
                document.getElementById('player').style.pointerEvents = 'auto'
              }
            })
            clearInterval(intervalT)
            intervalT = setInterval(() => {
              const frameInterval = Math.floor(player.currentTime() * frameRate)
              if (objCameraPositions[`${frameInterval}`]) {
                const interpolateCoordinates = (start, end, factor) => ({
                  x: interpolateLinear(start.x, end.x, factor),
                  y: interpolateLinear(start.y, end.y, factor),
                  z: interpolateLinear(start.z, end.z, factor),
                })

                const currentFrame = Math.floor(player.currentTime() * frameRate)
                const nextFrame = Math.floor((player.currentTime() + 0.05) * frameRate)

                if (objCameraPositions[`${currentFrame}`] && objCameraPositions[`${nextFrame}`]) {
                  const interpolatedPosition = interpolateCoordinates(
                    objCameraPositions[`${currentFrame}`],
                    objCameraPositions[`${nextFrame}`],
                    0.5,
                  )

                  const camera = getVrCamera(player)
                  if (camera?.position?.set) {
                    camera.position.set(
                      interpolatedPosition.x,
                      avgY,
                      interpolatedPosition.z,
                    )
                  }
                }
              }
              if (player.currentTime() < item.start_second || player.currentTime() > item.end_second) {
                clearInterval(intervalT)
                const orientation = getVrControls(player)?.orientation
                orientation?.enableDevice?.()
                document.getElementById('player').style.pointerEvents = 'auto'
              }
            }, 60 / frameRate)
          })
        } else if (!arrayIsNotEmpty(item.cam_coords) && manualViewer.value) {
          restartPlayer()
          setTrackedVideo(item.start_second)
        } else {
          if (arrayIsNotEmpty(item.cam_coords)) {
            const coordinates = item.cam_coords
            const objCameraPositions = arrayToObject(coordinates)
            const yValues = coordinates.map(el => Object.values(el)[0].y)
            const avgY = yValues.reduce((sum, val) => sum + val, 0) / (yValues.length || 1)
            player.currentTime(item.start_second)
            const orientationControls = getVrControls(player)?.orientation
            orientationControls?.disableDevice?.()
            document.getElementById('player').style.pointerEvents = 'none'

            const frameRate = 20
            player.off('timeupdate')
            player.currentTime(item.start_second)
            player.on('timeupdate', () => {
              const current = player.currentTime()
              if (current < item.start_second || current > item.end_second) {
                clearInterval(intervalT)
                const orientation = getVrControls(player)?.orientation
                orientation?.enableDevice?.()
                document.getElementById('player').style.pointerEvents = 'auto'
              }
            })
            clearInterval(intervalT)
            intervalT = setInterval(() => {
              const frameInterval = Math.floor(player.currentTime() * frameRate)
              if (objCameraPositions[`${frameInterval}`]) {
                const interpolateCoordinates = (start, end, factor) => ({
                  x: interpolateLinear(start.x, end.x, factor),
                  y: interpolateLinear(start.y, end.y, factor),
                  z: interpolateLinear(start.z, end.z, factor),
                })

                const currentFrame = Math.floor(player.currentTime() * frameRate)
                const nextFrame = Math.floor((player.currentTime() + 0.05) * frameRate)

                if (objCameraPositions[`${currentFrame}`] && objCameraPositions[`${nextFrame}`]) {
                  const interpolatedPosition = interpolateCoordinates(
                    objCameraPositions[`${currentFrame}`],
                    objCameraPositions[`${nextFrame}`],
                    0.5,
                  )

                  const camera = getVrCamera(player)
                  if (camera?.position?.set) {
                    camera.position.set(
                      interpolatedPosition.x,
                      avgY,
                      interpolatedPosition.z,
                    )
                  }
                }
              }
              if (player.currentTime() < item.start_second || player.currentTime() > item.end_second) {
                clearInterval(intervalT)
                const orientation = getVrControls(player)?.orientation
                orientation?.enableDevice?.()
                document.getElementById('player').style.pointerEvents = 'auto'
              }
            }, 60 / frameRate)
          } else {
            player.currentTime(item.start_second)
          }
        }
      }

      // }
    }

    async function getRecordingDetailBy() {
      const axions = new Axios.Axios({})
      try {
        // const token = 'yJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ0ZXN0MDEiLCJpYXQiOjE3MjY1NzUwNzMsIm5iZiI6MTcyNjU3NTA3MywianRpIjoiYWYxNmZlZjAtZGIxMC00Njc5LWJjMGUtMzhkNjVjNzQxMzY0IiwiZXhwIjoxNzI2NTc1OTczLCJ0eXBlIjoiYWNjZXNzIiwiZnJlc2giOmZhbHNlLCJzY29wZXMiOlsibW9iaWxlX3VzZXIiXX0.wcrUvilQlz-5WFgVvo9YgLG3v6JdrOOxCgpCERQkZrg'
        const { data } = await axions.get(`${BASE_URL}highlight/recording/mobile/${params.user}`, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Accept-Language': getI18nLanguage(),
            'el-token': `Bearer ${params.hash}`,
          },
        })
        const videoInfo = JSON.parse(data)

        if (videoInfo.ok) {
          videoRNData.value = { ...videoInfo.data }
          // eslint-disable-next-line no-use-before-define
          checkHighlightStatus(videoInfo.data.highlights)
          if (videoInfo.data.status !== 'A') {
            // eslint-disable-next-line no-use-before-define
            checkProcessingPercent()
          }
          const highlightTime = videoInfo.data.highlights_times.map((timeh, ih) => ({
            time: timeh, text: String(timeh), overlayText: String(ih),
          }))
          // eslint-disable-next-line no-use-before-define
          addMarkers(highlightTime)
        }
      } catch (error) {
        console.log('🚀 ~ getRecordingDetailBy ~ error:', error)
      }
    }

    async function getVideoDetailby() {
      const userId = query.userId || ''
      const axions = new Axios.Axios({})
      try {
        const { data } = await axions.get(`${BASE_URL}highlight/video/mobile/${params.user}/${userId}`, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Accept-Language': getI18nLanguage(),
            'el-token': `Bearer ${params.hash}`,
          },
        })
        const videoInfo = JSON.parse(data)

        if (videoInfo.ok) {
          videoRNData.value = { ...videoInfo.data }
          // eslint-disable-next-line no-use-before-define
          checkHighlightStatus(videoInfo.data.highlights)
          if (videoInfo.data.status === 'P') {
            const lastProcessingState = videoInfo.data.processing_percent
            processingPercent.value = lastProcessingState || 0
            // eslint-disable-next-line no-use-before-define
            checkProcessingPercent()
          }
          const highlightTime = videoInfo.data.highlights_times.map((timeh, ih) => ({
            time: timeh, text: String(timeh), overlayText: String(ih),
          }))
          // eslint-disable-next-line no-use-before-define
          addMarkers(highlightTime)
        }
      } catch (error) {
        console.log('🚀 ~ getRecordingDetailBy ~ error:', error)
      }
    }

    async function getProcessingPercent() {
      try {
        const axions = new Axios.Axios({})
        const { data } = await axions.get(`${BASE_URL}video/processing_percent/${params.user}`, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Accept-Language': getI18nLanguage(),
            'el-token': `Bearer ${params.hash}`,
          },
        })
        const percentData = JSON.parse(data)
        if (percentData.ok === 1) {
          processingPercent.value = percentData.data.processing_percent

          // processingPercent.value+= 1
          localStorage.setItem(`vjs_processing-${params.user}`, processingPercent.value)
          if (processingPercent.value <= 99) {
            // eslint-disable-next-line no-use-before-define
            checkProcessingPercent()
          } else {
            repeatForPercent.stopInterval()
            // eslint-disable-next-line no-use-before-define
            await reloadHighlight()
            localStorage.removeItem(`vjs_processing-${params.user}`)
            restartPlayer()
            if (!videoRNData.value.video_url && !videoRNData.value.left_video_url) {
              setManualViewerVideo(0)
            } else {
              setTrackedVideo(0)
            }
          }
        }
      } catch (error) {
        processingPercent.value = 0
      }
    }

    async function checkProcessingPercent() {
      if (processingPercent.value <= 99) {
        repeatForPercent.stopInterval()
        repeatForPercent.repeat(10000, getProcessingPercent)
      } else {
        repeatForPercent.stopInterval()
      }
    }
    const reloadHighlight = async () => {
      // eslint-disable-next-line no-use-before-define
      removeMarkers()
      if (query.entity === 'recording') {
        await getRecordingDetailBy(params.user)
      } else {
        await getVideoDetailby(params.user)
      }
    }

    function verifyHighlights(localHighlight = [], highlights = []) {
      const firstLocal = localHighlight.shift()
      if (firstLocal) {
        const missingHighlight = highlights.find(highlight => highlight.id === firstLocal.id)
        if (missingHighlight && missingHighlight.highlight_url) {
          const highlightToShow = highlightPendingList.value.find(h => h.id === missingHighlight.id)
          highlightToShow.highlight_url = missingHighlight.highlight_url
          highlightToShow.thumbnail = missingHighlight.thumbnail
          highlightToShow.show = true

          // showHighlightCreated.value = true
          localStorage.setItem('highlightPendingList', JSON.stringify(localHighlight))
        }
      }
    }

    function hiddenModalByHighlight(highlight) {
      highlightPendingList.value = highlightPendingList.value.map(h => {
        if (h.id === highlight.id) {
          return {
            ...h,
            show: false,
          }
        }

        return {
          ...h,
        }
      })
    }

    function checkHighlightStatus(highlights = []) {
      if (manualViewer && newHighlightMV.value.highlight_id) {
        const lastHighlight = highlights.find(highlight => highlight.id === newHighlightMV.value.highlight_id)
        if (lastHighlight && lastHighlight.type !== 'stitched') {
          newHighlightMV.value = {
            ...newHighlightMV.value,
            ...lastHighlight,
          }
          showHighlightCreated.value = true

          return
        }
      }

      const highlightNotUrl = highlights.filter(highlight => !highlight?.highlight_url && (!arrayIsNotEmpty(highlight?.cam_coords) || highlight.type === 'stitched'))
      const localHighlightPending = localStorage.getItem('highlightPendingList')
      if (highlightNotUrl.length) {
        console.log('highlightNotUrl.length')
        if (localHighlightPending && JSON.parse(localHighlightPending).length) {
          verifyHighlights(JSON.parse(localHighlightPending), highlights)
        } else {
          highlightPendingList.value = [...highlightNotUrl]
          localStorage.setItem('highlightPendingList', JSON.stringify(highlightPendingList.value))
        }

        repeat.stopInterval()
        repeat.repeat(5000, reloadHighlight)
      } else {
        if (localHighlightPending) {
          verifyHighlights(JSON.parse(localHighlightPending), highlights)
        }
        repeat.stopInterval()
      }
    }

    async function requestCreateHighlight(body) {
      const axions = new Axios.Axios({})
      const strdata = JSON.stringify(body)
      try {
        const { data } = await axions.post(`${BASE_URL}highlight/`, strdata, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Accept-Language': getI18nLanguage(),
            'el-token': `Bearer ${params.hash}`,
          },
        })
        const videoInfo = JSON.parse(data)
        console.log('🚀 ~ requestCreateHighlight ~ videoInfo:', videoInfo)

        if (videoInfo.ok) {
          if (manualViewer.value) {
            newHighlightMV.value = {
              ...newHighlightMV.value,
              highlight_id: videoInfo.data.highlight_id,
            }
            success(vm.$t('highlight_view.highlight_created_toast'))
          } else success(vm.$t('highlight_view.highlight_creating_toast'))

          if (query.entity === 'recording') {
            getRecordingDetailBy(params.user)
          } else {
            getVideoDetailby(params.user)
          }
        }
      } catch (error) {
        console.log('🚀 ~ getRecordingDetailBy ~ error:', error)
      } finally {
        clearInterval(intervalHighlight)
        clearInterval(intervalT)
        clearTimeout(timeoutHighlight)
        currentTimeVideo.value = 0
        highlightName.value = ''
        newHighlight.value = {
          user_id: '',
          name: '',
          creation_date: moment().format('YYYY-MM-DD'),
          highlight_type: 'H',
          start_time: 0,
          end_time: 0,
          video_id: 0,
          recording_id: 0,
        }
      }
    }

    function onCloseModalNewHighlightMV() {
      showInputName.value = false
      highlightName.value = ''
      newHighlightMV.value = {
        name: '',
        thumbnail: '',
        highlight_id: null,
      }
      showHighlightCreated.value = false
    }

    function onCreateHighlight() {
      player.off('timeupdate')
      clearTimeout(timeoutHighlight)
      clearInterval(intervalHighlight)
      const p = document.getElementsByClassName('vjs-touch-nav')
      p[0].style = 'display: flex'
      player.controls(true)
      startCreateHighlight.value = false
      showInputName.value = false
      player.on('timeupdate', e => {
        player.controlBar.currentTimeDisplay.updateContent(e)
      })

      // const currentTime = player.currentTime()
      player.play()

      // restartPlayer()
      // setTrackedVideo(currentTime)
      const body = {
        ...newHighlight.value,
        name: highlightName.value,
        user_id: query.userId || '',
        creation_date: moment().format('YYYY-MM-DD'),
        video_id: query?.entity === 'recording' ? null : params.user,
        recording_id: query?.entity === 'recording' ? params.user : null,
        highlight_type: 'H',
      }
      if (videoRNData.value.video_type === 'S') {
        Object.assign(body, { side: camSelected.value === 1 ? 'L' : 'R' })
      } else {
        Object.assign(body, { side: null })
      }
      requestCreateHighlight(body)
    }

    function doAction(item, action = 'highlight') {
      newHighlightMV.value = {
        name: '',
        thumbnail: '',
        highlight_id: null,
      }
      const data = JSON.stringify({ action, item: { ...item, share_url: String(item.share_url).replace('console', 'app') } })

      hiddenModalByHighlight(item)
      console.log('action', action, inFullscreen.value)
      if (action === 'shared' && !!inFullscreen.value) {
        setFullScreen(player, false)
      }
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(data)
      }
    }

    function getFolders() {
      const axions = new Axios.Axios({})
      axions.get(`${BASE_URL}user/videos_folder/`, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'Accept-Language': getI18nLanguage(),
          'el-token': `Bearer ${params.hash}`,
        },
      })
        .then(response => {
          const resp = JSON.parse(response.data)
          if (Array.isArray(resp.data)) listFolder.value = [...resp.data]
        })
        .catch(error => {
          console.log(error)
        })
    }

    function onUnSaveHighlight(highlightId) {
      // eslint-disable-next-line no-use-before-define
      if (includeVideoID(highlightId)) {
        showUnSaveHighlightDialog.value = true
        highlightSelected.value = highlightId
      } else {
        // eslint-disable-next-line no-use-before-define
        addVideoId(highlightId)
      }
    }

    function onRemoveHighlight(item) {
      highlightSelected.value = item
      showDeleteHighlightDialog.value = true
    }

    async function removeHighlight() {
      try {
        showDeleteHighlightDialog.value = false
        const userId = query.userId || ''
        const axions = new Axios.Axios({})
        await axions.delete(`${BASE_URL}highlight/${highlightSelected.value.id}/${userId}`, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Accept-Language': getI18nLanguage(),
            'el-token': `Bearer ${params.hash}`,
          },
        })
        reloadHighlight()
        setTimeout(() => {
          reloadHighlight()
        }, 5000)
      } catch (error) {
        if (error?.data && error.data.message) {
          // showToast(error.data.message, 'error')
        }
      }
    }

    function updateFolders() {
      const axions = new Axios.Axios({})
      const strdata = JSON.stringify({ videos_folders: listFolder.value })
      axions.put(`${BASE_URL}user/videos_folder/`, strdata, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'Accept-Language': getI18nLanguage(),
          'el-token': `Bearer ${params.hash}`,
        },
      })
        .then(response => {
          console.log('update', response)
          getFolders()
        })
        .catch(error => {
          console.log(error)
        })
    }

    function includeVideoID(videoId) {
      if (listFolder.value.length) return listFolder.value[0].videos_ids.includes(videoId)

      return false
    }

    function addVideoId(videoId) {
      const newlist = listFolder.value[0]
      if (includeVideoID(videoId)) {
        newlist.videos_ids = newlist.videos_ids.filter(i => i !== videoId)
      } else {
        newlist.videos_ids.push(videoId)
      }
      showUnSaveHighlightDialog.value = false
      listFolder.value = [newlist]
      setTimeout(() => {
        updateFolders()
      }, 1000)
    }
    function onCancelHighlight() {
      player.off('timeupdate')
      clearTimeout(timeoutHighlight)
      clearInterval(intervalHighlight)
      const p = document.getElementsByClassName('vjs-touch-nav')
      p[0].style = 'display: flex'
      player.controls(true)

      startCreateHighlight.value = false
      showInputName.value = false
      currentTimeVideo.value = 0
      player.on('timeupdate', e => {
        player.controlBar.currentTimeDisplay.updateContent(e)
      })

      // const currentTime = player.currentTime()
      player.play()

      newHighlight.value = {
        user_id: '',
        name: '',
        creation_date: moment().format('YYYY-MM-DD'),
        highlight_type: 'H',
        start_time: 0,
        end_time: 0,
        video_id: 0,
        recording_id: 0,
      }

      // eslint-disable-next-line no-use-before-define
      // addBtnActionsInsidePlayer(actionBtnsDom.value, camsContainerDom.value)

      // initTouchEvents(player)

      // // restartPlayer()
      // if (!manualViewer.value) {
      //   setTrackedVideo(currentTime)
      // } else {
      //   setManualViewerVideo(currentTime)
      // }
    }

    function setHighlightMarks(elplayer, highlightTime = []) {
      const total = elplayer.duration()
      const p = document.getElementsByClassName('vjs-progress-holder vjs-slider vjs-slider-horizontal')

      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < highlightTime.length; i++) {
        // eslint-disable-next-line no-mixed-operators
        const left = `${highlightTime[i].time / total * 100}%`

        const { time } = highlightTime[i]
        const el = document.createElement('div')
        el.setAttribute('style', `left: ${left}`)
        el.setAttribute('data-time', `${time}`)
        el.classList.add('js-marker')
        p[0].append(el)
      }
    }

    function onSelectCam(mode, currentTime = null) {
      let elCurrentTime = 0
      if (currentTime != null) {
        elCurrentTime = currentTime
      } else {
        elCurrentTime = player.currentTime()
      }
      restartPlayer()
      if (mode === 'left') {
        camSelected.value = 1

        player.src(videoRNData.value.left_video_url)
        player.currentTime(elCurrentTime)
      } else {
        player.src(videoRNData.value.right_video_url)
        player.currentTime(elCurrentTime)
        camSelected.value = 2
      }
      const highlightTime = videoRNData.value.highlights_times.map((timeh, ih) => ({
        time: timeh, text: String(timeh), overlayText: String(ih),
      }))
      player.nuevo({
        shareMenu: false,
        zoomMenu: false,
        contextMenu: false,
        relatedMenu: false,
        rateMenu: false,
        settingsButton: false,
      })
      player.on('loadedmetadata', () => {
        setHighlightMarks(player, highlightTime)
        if (videoRNData.value.stitched_video_url && (videoRNData.value.left_video_url || videoRNData.value.video_url)) {
          generateBarManualViewerBtn(player)
        }
        generateRateBtn(player)
        generateFullScreenBtn(player, !inFullscreen.value ? 'vjs-icon-fs' : 'vjs-icon-fsExit', 12)

        // eslint-disable-next-line no-use-before-define
        addBtnActionsInsidePlayer(actionBtnsDom.value, camsContainerDom.value)
        if (!inFullscreen.value) {
          // eslint-disable-next-line no-use-before-define
          generateFullScreenBtn(player)
          document.getElementsByClassName('vjs-control-bar')[0].classList.add('fs-bar')
        } else {
          // eslint-disable-next-line no-use-before-define
          generateFullScreenBtn(player, 'vjs-icon-fsExit')
          document.getElementsByClassName('vjs-control-bar')[0].classList.remove('fs-bar')
        }
        player.muted(false)
        loading.value = false
      })

      initTouchEvents(player)

      player.on('error', () => {
        console.log('error', player.error())
        sendUserActivities(params.user, null, player.error())
      })
    }

    function addBtnActionsInsidePlayer(actions, cams) {
      document.querySelectorAll('.player')[0].appendChild(actions)
      if (cams) {
        document.querySelectorAll('.player')[0].appendChild(cams)
      }
      if (document.querySelectorAll('.vjs-time-divider')[0]) {
        document.querySelectorAll('.vjs-time-divider')[0].classList.remove('vjs-time-control')
      }
    }

    function removeMarkers() {
      const markers = document.getElementsByClassName('js-marker')
      // eslint-disable-next-line no-plusplus
      for (let index = 0; index < markers.length; index++) {
        const element = markers[index]
        element.remove()
      }
    }

    function addMarkers(highlightTime = []) {
      // eslint-disable-next-line no-underscore-dangle
      const p = document.getElementsByClassName('vjs-progress-holder vjs-slider vjs-slider-horizontal')
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < highlightTime.length; i++) {
        // eslint-disable-next-line no-mixed-operators
        const left = `${highlightTime[i].time / playerDuration.value * 100}%`

        const { time } = highlightTime[i]
        const el = document.createElement('div')
        el.setAttribute('style', `left: ${left}`)
        el.setAttribute('data-time', `${time}`)
        el.classList.add('js-marker')
        if (p[0]) p[0].append(el)
      }
    }

    function setPassGuide() {
      const passGuide = query?.showGuide
      if (passGuide === 'show' && !endGuide.value) {
        showGuide.value = true
        setTimeout(() => {
          showGuide.value = false
          endGuide.value = true
        }, 3000)
      }
    }

    onMounted(async () => {
      if (query?.theme === 'light') {
        isLightMode.value = true
      }
      console.log(nameInput.value)
      await reloadHighlight()
      getFolders()

      // permissionDeviceMotionEvent()
      // videoRNData.value = {
      //   ...videoRNData.value, video_url: '', left_video_url: '', stitched_video_url: 'https://fanaty-production.s3.us-west-004.backblazeb2.com/concatenated_video/stitcheddb5f8bb5.mp4',
      // }
      const videoInfo = {
        ...videoRNData.value,
      }
      actionBtnsDom.value = document.getElementById('action-container')
      camsContainerDom.value = document.getElementById('cams-container')
      const highlightTime = videoInfo.highlights_times.map((timeh, ih) => ({
        time: timeh, text: String(timeh), overlayText: String(ih),
      }))
      const srcUrl = videoInfo.left_video_url || videoInfo.video_url || videoInfo.stitched_video_url || ''
      const hasEndTag = String(srcUrl).includes('endtag=true')
      player = window.videojs('player', {
        disablePictureInPicture: true,
        aspectRatio: '16:9',
        liveui: !hasEndTag,
        controlBar: {
          fullscreenToggle: false,
        },
        userActions: {
          doubleClick: false,
        },
      })

      player.nuevo({
        playlistUI: false,
        playlistShow: false,
        playlistAutoHide: false,
        playlistNavigation: false,
        playlistRepeat: false,
        shareMenu: false,
        settingsButton: false,
        video_id: params.user,
        resume: true,
        slideImage: videoInfo.sprite_url,
        slideType: 'verical',
        slideWidth: 120,
        slideHeight: 60,
        dvrMin: 600,
      })
      if (!videoInfo.video_url && !videoInfo.left_video_url) {
        manualViewer.value = true
        showCustomControls.value = true
        if (!player.mediainfo) {
          player.mediainfo = {}
        }

        if (!player.mediainfo.projection) {
          player.mediainfo.projection = '360'
        }
        player.vr({
          projection: '360', forceVR: true, cameraFov: 90, debug: true,
        })

        player.src({ type: 'video/mp4', src: videoInfo.stitched_video_url, video_id: params.user })

        sendUserActivityInManualViewer(params.user)
        window.addEventListener('deviceorientation', event => {
          // Rotación alrededor del eje Z (0 a 360 grados)
          const { beta } = event // Inclinación frontal/trasera del dispositivo (-180 a 180 grados)
          if (beta > 89) {
            const vrInstance = getVrInstance(player)
            const camera = vrInstance?.camera
            if (camera?.position?.set) {
              camera.position.set(camera.position.x, 0, camera.position.z)
              vrInstance?.controls3d?.update?.()
            }
          }
        })
      } else {
        player.src({ type: 'video/mp4', src: videoInfo.left_video_url || videoInfo.video_url, video_id: params.user })
      }

      // player.load()
      player.ready(() => {
        const spinner = document.getElementsByClassName('vjs-loading-spinner')[0]
        spinner.setAttribute('style', 'display: block')

        if (manualViewer.value) {
          setTimeout(() => {
            loading.value = false
            // eslint-disable-next-line no-use-before-define
            setPassGuide()
          }, 6000)
        }

        // const pLabel = document.getElementsByClassName('p-label')
        // pLabel[0].innerHTML = 'Cameras'
      })

      player.on('loadedmetadata', () => {
        if (String(srcUrl).includes('endtag=true')) {
          player.removeClass('vjs-live')
          player.removeClass('vjs-liveui')
          if (player.liveTracker && typeof player.liveTracker.stopTracking === 'function') {
            player.liveTracker.stopTracking()
          }
        }

        // If the source is a live HLS stream with DVR, start from the
        // beginning of the seekable window (time 0 of the live buffer).
        try {
          const srcUrl2 = (videoInfo.left_video_url || videoInfo.video_url || '')
          const isHls = /\.m3u8(\?.*)?$/i.test(srcUrl2)
          const hasSeekable = typeof player.seekable === 'function' && player.seekable().length > 0
          const isLive = (player.liveTracker && typeof player.liveTracker.isLive === 'function' && player.liveTracker.isLive()) || player.duration() === Infinity
          if (isHls && hasSeekable && isLive) {
            const start = player.seekable().start(0)
            if (!Number.isNaN(start)) {
              // player.currentTime(start + 0.1)
            }
          }
        } catch (e) {
          // noop
        }

        const resumeTime = localStorage.getItem(`vjs_resume-${params.user}`)

        if (resumeTime && Number(resumeTime) < player.duration()) {
          player.currentTime(resumeTime)
        }
        if (videoInfo.stitched_video_url && (videoInfo.left_video_url || videoInfo.video_url)) {
          generateBarManualViewerBtn(player)
        }
        generateRateBtn(player)
        generateFullScreenBtn(player)

        // generateRateBtn(player)
        playerDuration.value = player.duration()
        addMarkers(highlightTime)
        loading.value = false
        if (manualViewer.value) {
          setTimeout(() => {
            const camera = getVrCamera(player)
            if (camera?.position?.set) {
              camera.position.set(-(Math.PI * 3), 0, 0)
            }
            setCameraConfig(player)
          }, 500)

          player.on('touchstart', () => {
            if (manualViewer.value) {
              setCameraConfig(player)

              clearInterval(touchInterval)
              clearTimeout(touchTimeout)
              touchInterval = setInterval(() => {
                touchDuration.value += 1
              }, 10)

              // eslint-disable-next-line no-use-before-define
              // eslint-disable-next-line no-unused-expressions
              typeof DeviceMotionEvent !== 'undefined'
                && typeof DeviceMotionEvent.requestPermission === 'function'
                && DeviceMotionEvent.requestPermission()
                  .then(ev => {
                    // eslint-disable-next-line no-unused-expressions
                    ev === 'granted' && window.addEventListener('devicemotion', motione => { console.log(motione) })
                  })
                  .catch(console.error)
            }
          })

          player.on('touchend', touchendEvent => {
            if (manualViewer.value) {
              requestMotionPermission()
            }

            clearInterval(touchInterval)
            if (touchDuration.value < 50) {
              if (document.querySelectorAll('.vjs-touch-nav')[0].classList.contains('touch-show')) {
                if (!touchendEvent.target.className.includes('control') && !touchendEvent.target.className.includes('actionBtn-title')) {
                  document.querySelectorAll('.vjs-touch-nav')[0].classList.remove('touch-show')
                  player.controlBar.hide()
                  showModeBtn.value = false
                }
              } else {
                console.log(touchendEvent.target.className)
                document.querySelectorAll('.vjs-touch-nav')[0].classList.add('touch-show')
                player.controlBar.show()
                if (!touchendEvent.target.className.includes('actionBtn-title')) {
                  showModeBtn.value = true
                }
                touchTimeout = setTimeout(() => {
                  showModeBtn.value = false
                  document.querySelectorAll('.vjs-touch-nav')[0].classList.remove('touch-show')
                  player.controlBar.hide()
                }, 3000)
              }
            }
          })
        }

        // Playbtn.click()
        touchTimeout = setTimeout(() => {
          if (document.querySelectorAll('.vjs-touch-nav')[0]) {
            document.querySelectorAll('.vjs-touch-nav')[0].classList.remove('touch-show')
            player.controlBar.hide()
          }
        }, 3000)
      })

      setTimeout(() => {
        videoLoaded.value = true
        addBtnActionsInsidePlayer(actionBtnsDom.value, camsContainerDom.value)
      }, 3000)
      if (!manualViewer.value) {
        initTouchEvents(player)
      }

      player.on('error', () => {
        console.log('error', player.error().message)
        sendUserActivities(params.user, null, player.error().message)
      })
      window.addEventListener('resize', () => {
        if (manualViewer.value) {
          const camera = getVrCamera(player)
          if (camera) {
            camera.aspect = inFullscreen.value ? 2.1 : 1.77
            camera.updateProjectionMatrix?.()
          }
          getVrControls(player)?.handleResize?.()
        }
      })
    })

    return {
      // data
      newHighlight,
      manualViewer,
      startCreateHighlight,
      showInputName,
      errorMessages,
      validators: {
        required,
        emailValidator,
        minLengthValidator,
      },
      highlightName,
      currentTimeVideo,
      highlightSelected,
      showCustomControls,
      camSelected,
      inFullscreen,
      showModeBtn,
      videoLoaded,
      isLightMode,
      showGuide,
      loading,
      showDeleteHighlightDialog,
      showUnSaveHighlightDialog,
      showHighlightCreated,
      highlightPendingList,
      highlightNameRules,
      nameInput,
      newHighlightMV,
      processingPercent,

      // methods
      formatCurrency,
      defaultDownloadAppByOS,
      changeTo,
      isAndroidComputed,
      isIOSComputed,
      videoRNData,
      onStartHighlight,
      onStopHighlight,
      onSaveHighlight: onCreateHighlight,
      doAction,
      onSelectHighlight,
      addVideoId,
      includeVideoID,
      removeHighlight,
      onCancelHighlight,
      onSelectCam,
      onRemoveHighlight,
      onUnSaveHighlight,
      hiddenModalByHighlight,
      arrayIsNotEmpty,
      reloadHighlight,
      onCloseModalNewHighlightMV,

      // themeConfig
      appLogoTitle: themeConfig.app.logoTitle,
      t,
      icons: {
        mdiClose,
        mdiBookmarkOutline,
        mdiExportVariant,
        mdiCheckBold,
        mdiTrashCanOutline,
        mdiPlay,
        mdiStop,
      },
    }
  },
}
